<template>
  <div class="container v-content-container tooltip-wrapper popup-wrapper">
    <div class="row tooltip-wrapper">
      <div class="col-xs-12">
        <h1>
          <span v-if="selectedBookingId != null">
            {{ noDataExist ? "Inventory Product Booking" : bookingName }}
          </span>
          <span v-else-if="!loading">
            {{ $label("booking.new_booking", "New Booking") }}
          </span>
        </h1>
      </div>
    </div>

    <div class="row mt-8">
      <div class="col-xs-12">&nbsp;</div>
    </div>

    <error404 v-if="noDataExist" />

    <template v-else>
      <new-customer-modal
        :showModal="showAddCustomerModal"
        @close="closeAddCustomerModal"
        @onSuccess="onSelectCustomer"
      />

      <div v-show="loading" class="row">
        <div class="col-xs-12">
          <view-loader
            margin-top-pixels="15"
            border-color="primary"
          ></view-loader>
        </div>
      </div>

      <div class="row"><div class="col-xs-12">&nbsp;</div></div>

      <!-- Tab panes -->
      <div v-show="!loading" class="tab-content tooltip-wrapper">
        <div id="form-booking-data">
          <div class="tab-pane active" id="booking-data">
            <div class="row">
              <div class="col-sm-6">
                <h2>
                  <i class="fa fa-fw fa-lg fa-dot-circle-o"></i>
                  <span id="booking-header">
                    {{ $label("booking.what_who", "What | Who") }}</span
                  >
                </h2>
                <p></p>
                <div class="v-form-partial">
                  <div class="v-form">
                    <fieldset>
                      <div class="row">
                        <!-- BEGIN Product -->
                        <section class="col col-9">
                          <label class="label">{{
                            $label("booking.product", "Product")
                          }}</label>
                          <label class="select">
                            <select
                              id="booking-product"
                              v-model="selectedBooking.inventory_product_id"
                              :disabled="updating"
                            >
                              <option
                                v-for="product in products"
                                :value="product.id"
                                :key="product.id"
                              >
                                {{ product.name }}
                              </option>
                            </select>
                            <i></i>
                          </label>
                          <p
                            v-if="
                              hasError('inventory_product_id') ||
                                hasError(
                                  'inventory_products.0.inventory_product_id'
                                )
                            "
                            class="text-danger"
                            style="word-break: break-all"
                          >
                            {{
                              getError("inventory_product_id") ||
                                getError(
                                  "inventory_products.0.inventory_product_id"
                                )
                            }}
                          </p>
                        </section>
                        <!-- End Product -->

                        <!-- BEGIN Quantity -->
                        <section class="col col-3">
                          <label class="label">{{
                            $label("booking.quantity", "Quantity")
                          }}</label>

                          <label class="select">
                            <select
                              id="booking-quantity"
                              v-model="selectedBooking.units"
                              :disabled="
                                updating ||
                                  !selectedBooking.inventory_product_id
                              "
                            >
                              <option
                                v-for="(_, index) in Array(maxAvailableUnits)"
                                :key="index"
                                :value="index + 1"
                                >{{ index + 1 }}</option
                              >
                            </select>
                            <i></i>
                          </label>
                          <p
                            v-if="
                              hasError('units') ||
                                hasError('inventory_products.0.units')
                            "
                            class="text-danger"
                            style="word-break: break-all"
                          >
                            {{
                              getError("units") ||
                                getError("inventory_products.0.units")
                            }}
                          </p>
                        </section>
                        <!-- END Quantity -->
                      </div>
                      <div class="row">
                        <section class="col col-12">
                          <label class="label">{{
                            $label("booking.customer", "Customer")
                          }}</label>
                          <div class="flex-between">
                            <searchable-select
                              class="col-10"
                              v-model="selectedBooking.customer"
                              :searchResult="customers"
                              :placeholder="
                                $label(
                                  'booking.customer_search',
                                  'Search customer'
                                )
                              "
                              @change="onSearchChange"
                            >
                            </searchable-select>
                            <button
                              type="button"
                              class="btn btn-primary user-plus-button"
                              @click="openAddCustomerModal"
                            >
                              <i class="fa fa-user-plus"></i>
                            </button>
                          </div>
                          <p v-if="hasError('customer_id')" class="text-danger">
                            {{ getError("customer_id") }}
                          </p>
                        </section>
                      </div>

                      <div class="row">
                        <!-- BEGIN payment method -->
                        <section class="col col-12">
                          <label class="label">{{
                            $label("booking.payment_method", "Payment Method")
                          }}</label>
                          <label class="select">
                            <select
                              id="booking-payment-method"
                              v-model="selectedBooking.paymentMethod"
                              :disabled="updating"
                            >
                              <option
                                v-for="paymentType in paymentTypes"
                                :value="paymentType.id"
                                :key="paymentType.id"
                              >
                                {{ paymentType.slug }}
                              </option>
                            </select>
                            <i></i>
                          </label>
                          <p
                            v-if="hasError('payment_type_id')"
                            class="text-danger"
                          >
                            {{ getError("payment_type_id") }}
                          </p>
                        </section>
                        <!-- END payment method -->
                      </div>

                      <!-- BEGIN Remarks -->
                      <section>
                        <label class="label">{{
                          $label("booking.remarks", "Remarks")
                        }}</label>
                        <label class="textarea">
                          <i class="icon-append fa fa-comment"></i>
                          <textarea
                            v-model="selectedBooking.remarks"
                            :disabled="updating"
                            id="booking-note"
                            rows="3"
                          >
                          </textarea>
                        </label>
                      </section>
                      <!-- END Remarks -->
                    </fieldset>
                  </div>
                </div>
              </div>

              <div class="col-sm-6 tooltip-wrapper">
                <h2>
                  <i class="fa fa-fw fa-lg fa-calendar"></i>
                  {{ $label("booking.when_price", "When | Price") }}
                </h2>
                <p></p>
                <div class="v-form-partial">
                  <div class="v-form">
                    <fieldset>
                      <section>
                        <label class="label">
                          {{ $label("booking.from", "From") }}
                        </label>
                        <label class="flex-between">
                          <label class="input col-6 mr-1">
                            <i class="icon-append fa fa-calendar"></i>
                            <date-picker
                              v-model="selectedBooking.from.date"
                              :format="dateFormat"
                              :placeholder="dateFormat"
                              class="input"
                              id="booking-start-date"
                            >
                            </date-picker>
                          </label>
                          <label class="input col-6 ml-1">
                            <i class="icon-append fa fa-clock-o"></i>
                            <date-picker
                              v-model="selectedBooking.from.time"
                              :format="timeFormat"
                              :placeholder="timeFormat"
                              type="time"
                              class="input"
                              id="booking-start-time"
                            >
                            </date-picker>
                          </label>
                        </label>
                        <p
                          v-if="
                            hasError('starts_at') ||
                              hasError('inventory_products.0.starts_at')
                          "
                          class="text-danger"
                        >
                          {{
                            getError("starts_at") ||
                              getError("inventory_products.0.starts_at")
                          }}
                        </p>
                      </section>
                      <section>
                        <label class="label">
                          {{ $label("booking.to", "To") }}
                        </label>
                        <label class="flex-between">
                          <label class="input col-6 mr-1">
                            <i class="icon-append fa fa-calendar"></i>
                            <date-picker
                              v-model="selectedBooking.to.date"
                              :format="dateFormat"
                              :placeholder="dateFormat"
                              class="input"
                              id="booking-end-date"
                            >
                            </date-picker>
                          </label>

                          <label class="input col-6 ml-1">
                            <i class="icon-append fa fa-clock-o"></i>
                            <date-picker
                              v-model="selectedBooking.to.time"
                              :format="timeFormat"
                              :placeholder="timeFormat"
                              class="input"
                              type="time"
                              id="booking-end-time"
                            >
                            </date-picker>
                          </label>
                        </label>
                        <p
                          v-if="
                            hasError('ends_at') ||
                              hasError('inventory_products.0.ends_at')
                          "
                          class="text-danger"
                        >
                          {{
                            getError("ends_at") ||
                              getError("inventory_products.0.ends_at")
                          }}
                        </p>
                      </section>
                      <div class="flex-between">
                        <section class="col-9 mr-1">
                          <label class="label">
                            {{
                              $label("booking.price_per_unit", "Price per unit")
                            }}
                          </label>
                          <label class="input">
                            <input
                              id="booking-price-per-unit"
                              :value="selectedBooking.pricePerUnit + ' EUR'"
                              readonly
                              :class="{
                                'is-disabled': selectedBooking.use_manual_price
                              }"
                            />
                          </label>
                        </section>

                        <section class="col-3 ml-1">
                          <label class="label">
                            {{ $label("booking.discount", "Discount") }}
                          </label>
                          <label class="select">
                            <select
                              id="booking-discount"
                              v-model="selectedBooking.discount_id"
                              :disabled="selectedBooking.use_manual_price"
                            >
                              <option
                                v-for="discount in discounts"
                                :key="discount.id"
                                :value="discount.id"
                                >{{ discount.value }}</option
                              >
                            </select>
                            <i></i>
                          </label>
                        </section>
                      </div>

                      <div class="flex-between">
                        <section class="flex-1 mr-1">
                          <label class="label">
                            {{ $label("booking.oversteer", "Oversteer") }}
                          </label>
                          <label class="checkbox">
                            <input
                              type="checkbox"
                              id="booking-use-manual-price"
                              v-model="selectedBooking.use_manual_price"
                            />
                            {{ $label("booking.manual_price", "Manual price") }}
                            <i></i>
                          </label>
                          <p
                            v-if="
                              hasError('use_manual_price') ||
                                hasError(
                                  'inventory_products.0.use_manual_price'
                                )
                            "
                            class="text-danger"
                          >
                            {{
                              getError("use_manual_price") ||
                                getError(
                                  "inventory_products.0.use_manual_price"
                                )
                            }}
                          </p>
                        </section>

                        <section class="flex-1 ml-1 mr-1">
                          <label class="label">
                            {{ $label("booking.vat", "Vat").toUpperCase() }}
                          </label>
                          <label class="input">
                            <label class="select">
                              <select
                                id="booking-manual-price-vat"
                                v-model="selectedBooking.manual_price_vat_id"
                                :disabled="
                                  updating || !selectedBooking.use_manual_price
                                "
                              >
                                <option
                                  v-for="vat in vats"
                                  :value="vat.id"
                                  :key="vat.id"
                                >
                                  {{ vat.name }}
                                </option>
                              </select>
                              <i></i>
                            </label>
                          </label>
                        </section>

                        <section class="flex-1 ml-1">
                          <label class="label">
                            {{ $label("booking.total_price", "Total price ") }}
                            (gross)
                          </label>
                          <label class="input">
                            <i class="icon-append fa fa-euro"></i>
                            <input
                              id="booking-manual-price-gross"
                              v-model="
                                selectedBooking.manual_price_amount_gross
                              "
                              type="number"
                              name="total_price"
                              :readonly="!selectedBooking.use_manual_price"
                              :class="{
                                'is-disabled': !selectedBooking.use_manual_price
                              }"
                            />
                          </label>
                        </section>
                      </div>

                      <div class="flex-between">
                        <section class="flex-1 mr-1">
                          <label class="label">
                            {{ $label("booking.net", "Net") }}
                          </label>
                          <label class="input">
                            <i class="icon-append fa fa-euro"></i>
                            <input
                              type="number"
                              id="booking-amount-net"
                              readonly
                              :class="{
                                'is-disabled': true
                              }"
                              :value="selectedBooking.amount_net"
                            />
                          </label>
                        </section>

                        <section class="flex-1 ml-1 mr-1">
                          <label class="label">
                            {{ $label("booking.vat", "Vat").toUpperCase() }}
                          </label>
                          <label class="input">
                            <i class="icon-append fa fa-euro"></i>
                            <input
                              type="number"
                              readonly
                              :class="{
                                'is-disabled': true
                              }"
                              id="booking-vat"
                              :value="selectedBooking.vat"
                            />
                          </label>
                        </section>

                        <section class="flex-1 ml-1">
                          <label class="label">
                            {{ $label("booking.gross", "Gross") }}
                            <a href="#"><i class="fa fa-info-circle"></i></a>
                          </label>
                          <label class="input">
                            <i class="icon-append fa fa-euro"></i>
                            <input
                              type="number"
                              id="booking-amount-gross"
                              readonly
                              :class="{
                                'is-disabled': true
                              }"
                              v-model="selectedBooking.amount_gross"
                            />
                          </label>
                        </section>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>

            <div class="row"><div class="col-xs-12"></div></div>
          </div>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-center">
              <info-button
                class="mr-1"
                :class="{ 'is-disabled': updating }"
                id="booking-invest-button"
                icon="fa fa-fw fa-lg fa-check-square-o"
                :text="$label('booking.invest', 'Invest')"
                @click.native="createOrUpdateBooking"
              >
              </info-button>

              <warning-button
                class="mr-1"
                :class="{ 'is-disabled': updating }"
                id="cancel-booking-button"
                icon="fa fa-fw fa-lg fa-times"
                :text="$label('common.cancel', 'Cancel')"
                @click.native="cancelBooking"
              >
              </warning-button>

              <info-button
                class="mr-1"
                :class="{
                  'is-disabled': updating || selectedBookingId == null
                }"
                id="paid-booking-button"
                icon="fa fa-fw fa-lg fa-check"
                :text="$label('booking.paid', 'Paid')"
              >
              </info-button>

              <success-button
                :class="{
                  'is-disabled': updating || selectedBookingId == null
                }"
                id="details-booking-button"
                icon="fa fa-fw fa-lg fa-file-text-o"
                :text="$label('booking.billing_details', 'Billing Details')"
              >
              </success-button>
            </div>
          </div>
        </div>
      </div>

      <div class="row"><div class="col-xs-12">&nbsp;</div></div>

      <div class="row mb-4">
        <div class="col-xs-12"></div>
      </div>
    </template>
  </div>
</template>

<script>
import Api from "@/api";
import swal from "sweetalert";
import FormErrorsMixin from "@/mixins/FormErrors";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";

import "vue-swatches/dist/vue-swatches.css";

import ViewLoader from "@/components/Common/ViewLoader";
import InfoButton from "@/components/Common/Buttons/InfoButton";
import SuccessButton from "@/components/Common/Buttons/SuccessButton";
import WarningButton from "@/components/Common/Buttons/WarningButton";
import NewCustomerModal from "@/components/Customers/Customer/NewCustomerModal";
import SearchableSelect from "@/components/Common/Select/SearchableSelect";
import Error404 from "@/components/Common/Error404";

import "vue-slider-component/theme/default.css";

export default {
  name: "BookingInventoryProduct",

  mixins: [FormErrorsMixin],

  components: {
    ViewLoader,
    InfoButton,
    SuccessButton,
    WarningButton,
    NewCustomerModal,
    DatePicker,
    SearchableSelect,
    Error404
  },

  data() {
    return {
      loading: false,
      updating: false,
      noDataExist: false,
      bookingName: null,
      showAddCustomerModal: false,
      dateFormat: "DD.MM.YYYY",
      timeFormat: "HH:mm",
      selectedBooking: {
        paymentMethod: null,
        remarks: null,
        customer: null,
        from: {
          date: null,
          time: null
        },
        to: {
          date: null,
          time: null
        },
        inventory_product_id: null,
        pricePerUnit: 0,
        discount_id: null,
        amount_net: null,
        amount_gross: null,
        vat: null,
        manual_price_vat_id: null,
        manual_price_amount_gross: null,
        use_manual_price: false,
        units: 0
      },
      selectedBookingId: null,
      paymentTypes: [],
      discounts: [],
      customers: [],
      customerList: [],
      products: [],
      vats: [],
      validatedInputs: [
        "customer_id",
        "payment_type_id",
        "inventory_product_id",
        "units",
        "starts_at",
        "ends_at",
        "use_manual_price",
        "inventory_products.0.customer_id",
        "inventory_products.0.payment_type_id",
        "inventory_products.0.inventory_product_id",
        "inventory_products.0.units",
        "inventory_products.0.starts_at",
        "inventory_products.0.ends_at",
        "inventory_products.0.use_manual_price"
      ],
      debounce: null
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.selectedBookingId = vm.$route.params.booking_id;
      if (
        typeof vm.selectedBookingId !== "undefined" &&
        vm.selectedBookingId !== null
      ) {
        vm.getProductBooking();
        if (vm.$route.query.customer_created) {
          swal("Success!", "The Customer was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
        if (vm.$route.query.booking_created) {
          swal("Success!", "The Booking was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
      }
      vm.getProducts();
      vm.getVats();
      vm.getPaymentTypes();
      vm.getDiscounts();
    });
  },

  beforeRouteUpdate(to, from, next) {
    if (
      typeof this.selectedBookingId !== "undefined" &&
      this.selectedBookingId !== null
    ) {
      this.getProductBooking();
    }
    this.getProducts();
    this.getVats();
    this.getPaymentTypes();
    this.getDiscounts();
    next();
  },

  mounted: function() {
    this.getProducts();
    this.getVats();
    this.getPaymentTypes();
    this.getDiscounts();
  },

  computed: {
    maxAvailableUnits() {
      let inventoryProduct = null;
      if (this.products) {
        inventoryProduct = this.products.find(
          product => product.id === this.selectedBooking.inventory_product_id
        );
      }
      return inventoryProduct !== null && inventoryProduct !== undefined
        ? inventoryProduct.max_available_units
        : 0;
    }
  },

  watch: {
    "selectedBooking.inventory_product_id": function(newState) {
      const inventoryProduct =
        this.products && this.products.find(product => product.id === newState);
      if (newState !== null && inventoryProduct) {
        this.selectedBooking.units = 1;
        this.selectedBooking.pricePerUnit =
          inventoryProduct.price.form === "gross"
            ? inventoryProduct.price.amount_gross
            : inventoryProduct.price.amount_net;
      }
    }
  },

  methods: {
    cancelBooking() {
      this.$router.push({ name: "BookingInventoryProduct" });
    },

    createOrUpdateBooking() {
      if (this.selectedBookingId == null) {
        this.createBooking();
      } else {
        this.updateBooking();
      }
    },

    generateSavingData(type = "create") {
      if (type === "create") {
        return {
          customer_id: this.selectedBooking.customer.id,
          payment_type_id: this.selectedBooking.paymentMethod,
          internal_note: this.selectedBooking.remarks,
          inventory_products: [
            {
              inventory_product_id: this.selectedBooking.inventory_product_id,
              discount_id: this.selectedBooking.discount_id,
              units: this.selectedBooking.units,
              starts_at:
                this.convertDateTime(
                  `${this.$moment(this.selectedBooking.from.date).format(
                    this.dateFormat
                  )} ${this.$moment(this.selectedBooking.from.time).format(
                    this.timeFormat
                  )}`
                ) + ":00",
              ends_at:
                this.convertDateTime(
                  `${this.$moment(this.selectedBooking.to.date).format(
                    this.dateFormat
                  )} ${this.$moment(this.selectedBooking.to.time).format(
                    this.timeFormat
                  )}`
                ) + ":00",
              use_manual_price: this.selectedBooking.use_manual_price,
              manual_price_amount_gross: this.selectedBooking
                .manual_price_amount_gross,
              manual_price_vat_id: this.selectedBooking.manual_price_vat_id
            }
          ]
        };
      } else if (type === "update") {
        return {
          customer_id: this.selectedBooking.customer.id,
          payment_type_id: this.selectedBooking.paymentMethod,
          internal_note: this.selectedBooking.remarks,
          inventory_product_id: this.selectedBooking.inventory_product_id,
          discount_id: this.selectedBooking.discount_id,
          units: this.selectedBooking.units,
          starts_at:
            this.convertDateTime(
              `${this.$moment(this.selectedBooking.from.date).format(
                this.dateFormat
              )} ${this.$moment(this.selectedBooking.from.time).format(
                this.timeFormat
              )}`
            ) + ":00",
          ends_at:
            this.convertDateTime(
              `${this.$moment(this.selectedBooking.to.date).format(
                this.dateFormat
              )} ${this.$moment(this.selectedBooking.to.time).format(
                this.timeFormat
              )}`
            ) + ":00",
          use_manual_price: this.selectedBooking.use_manual_price,
          manual_price_amount_gross: this.selectedBooking
            .manual_price_amount_gross,
          manual_price_vat_id: this.selectedBooking.manual_price_vat_id
        };
      }
    },

    getProductBooking() {
      this.loading = true;
      const endpoint = this.$partnerEndpoint(
        `bookings/inventory-products/${this.selectedBookingId}`
      );

      Api()
        .get(endpoint)
        .then(response => {
          const productBooking = response.data.data;
          const customer = productBooking.booking.customer;

          this.selectedBooking.customer = {
            id: customer.id,
            name: `${customer.last_name} ${customer.first_name}`
          };
          this.bookingName = "Inventory Product Booking";
          this.selectedBooking.paymentMethod =
            productBooking.booking.payment_type.id;
          this.selectedBooking.remarks = productBooking.booking.internal_note;
          this.selectedBooking.inventory_product_id =
            productBooking.inventory_product.id;
          this.selectedBooking.pricePerUnit =
            productBooking.inventory_product_price.form === "gross"
              ? productBooking.inventory_product_price.amount_gross
              : productBooking.inventory_product_price.amount_net;
          this.selectedBooking.discount_id = productBooking.discount?.id;
          this.selectedBooking.from = {
            date: new Date(productBooking.starts_at),
            time: new Date(productBooking.starts_at)
          };
          this.selectedBooking.to = {
            date: new Date(productBooking.ends_at),
            time: new Date(productBooking.ends_at)
          };
          this.selectedBooking.units = productBooking.units;
          this.selectedBooking.amount_net =
            productBooking.booking.total_price.amount_net;
          this.selectedBooking.amount_gross =
            productBooking.booking.total_price.amount_gross;
          this.selectedBooking.vat =
            productBooking.booking.total_price.vat_amount;
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.noDataExist = true;
          }
          this.products = [];
          this.storeErrors(error.response.data.errors);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    createBooking() {
      if (this.updating) {
        return;
      }

      this.resetErrors();
      this.updating = true;
      const endpoint = this.$partnerEndpoint("bookings/inventory-products");
      const bookingInfo = this.generateSavingData("create");

      Api()
        .post(endpoint, bookingInfo)
        .then(response => {
          this.selectedBookingId = response.data.data.id;
          this.$router.push({
            name: "BookingInventoryProductDetails",
            params: { booking_id: this.selectedBookingId },
            query: { booking_created: true }
          });
        })
        .catch(error => {
          this.storeErrors(error.response.data.errors);
        })
        .finally(() => {
          this.updating = false;
        });
    },

    updateBooking() {
      if (this.loading || this.updating) {
        return;
      }

      this.resetErrors();
      this.updating = true;
      const endpoint = this.$partnerEndpoint(
        "bookings/inventory-products/" + this.selectedBookingId
      );
      const bookingInfo = this.generateSavingData("update");

      Api()
        .put(endpoint, bookingInfo)
        .then(() => {
          this.getProductBooking();
          swal({
            title: "Success!",
            text: "The booking was updated.",
            icon: "success"
          });
        })
        .catch(error => {
          this.storeErrors(error.response.data.errors);
        })
        .finally(() => {
          this.updating = false;
        });
    },

    onSearchChange(query) {
      if (query.length >= 2) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          this.getCustomers(query);
        }, 600);
      } else {
        this.customers = [];
      }
    },

    getCustomers(query = "") {
      const endpoint = this.$partnerEndpoint("customers");

      return Api()
        .get(endpoint, {
          params: {
            search: query
          }
        })
        .then(response => {
          this.customers = response.data.data.map(
            ({ id, first_name, last_name }) => ({
              id,
              name: `${last_name} ${first_name}`
            })
          );
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    getProducts() {
      this.loading = true;
      const endpoint = this.$partnerEndpoint("inventory-products");

      Api()
        .get(endpoint)
        .then(response => {
          this.products = response.data.data;
        })
        .catch(error => {
          console.log(error.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getPaymentTypes() {
      this.loading = true;
      const endpoint = this.$partnerEndpoint("payment-types");

      Api()
        .get(endpoint)
        .then(response => {
          this.paymentTypes = response.data.data;
          if (!this.selectedBookingId && this.paymentTypes.length > 0) {
            this.selectedBooking.paymentMethod = this.paymentTypes[0].id;
          }
        })
        .catch(error => {
          console.log(error.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getDiscounts() {
      this.loading = true;
      const endpoint = this.$partnerEndpoint("discounts");

      Api()
        .get(endpoint)
        .then(response => {
          this.discounts = response.data.data;
        })
        .catch(error => {
          console.log(error.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getVats() {
      this.loading = true;
      const endpoint = this.$partnerEndpoint("vats");

      Api()
        .get(endpoint)
        .then(response => {
          this.vats = response.data.data;
        })
        .catch(error => {
          console.log(error.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    openAddCustomerModal() {
      this.showAddCustomerModal = true;
    },

    closeAddCustomerModal() {
      this.showAddCustomerModal = false;
    },

    onSelectCustomer(customer) {
      this.showAddCustomerModal = false;
      this.selectedBooking.customer = {
        id: customer.id,
        name: `${customer.last_name} ${customer.first_name}`
      };
      this.customers = [this.selectedBooking.customer];
    }
  }
};
</script>

<style scoped>
.mr-1 {
  margin-right: 1rem;
}

.ml-1 {
  margin-left: 1rem;
}

.mb-4 {
  margin-bottom: 1.2rem;
}

.mt-8 {
  margin-top: 1.3rem;
}

.flex-1 {
  flex: 1;
}

.flex-between {
  display: flex;
  justify-content: space-between;
}

.user-plus-button {
  padding: 0 1.5rem;
  font-size: 2rem;
}
</style>
